import { Box, Container, Table, TableBody, TableCell, TableHead, TableRow, Button, Pagination } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { DashboardLayout } from "../../components/dashboard-layout";
import { theme } from "../../theme";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./account.css";

function Promo() {
    const [load, setLoad] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 10;
    const [data, setData] = useState([]);
    const [searchName, setSearchName] = useState("");
    const [status, setStatus] = useState("All");

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    useEffect(() => {
        if (load) {
            axios.get(`${process.env.REACT_APP_API_URL}/promo/history?page=${page}&limit=${limit}`)
                .then((res) => {
                    if (res.data.success) {
                        setData(res.data.data);
                        setTotalPages(res.data.totalPages || 1);
                    }
                    setLoad(false);
                })
                .catch(() => setLoad(false));
        }
    }, [load, page]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setLoad(true);
    };

    const formatDate = (m) => {
        if (!m) return "";
        const date = new Date(m);
        return date.getUTCFullYear() + "/" +
            ("0" + (date.getMonth() + 1)).slice(-2) + "/" +
            ("0" + date.getDate()).slice(-2) + " " +
            ("0" + date.getHours()).slice(-2) + ":" +
            ("0" + date.getMinutes()).slice(-2);
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 1 }}>
                    {load && (
                        <div className="loading" style={{ maxWidth: "100%" }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                            <div>
                                <h2 style={{ margin: 0, color: "#333", fontSize: "24px" }}>Lịch sử Giftcode</h2>
                                <p style={{ margin: "5px 0 0 0", color: "#666", fontSize: "14px" }}>Quản lý và theo dõi danh sách người dùng đã nhập Giftcode</p>
                            </div>
                        </Box>

                        <div className="form_set" style={{ marginTop: 0 }}>
                            <Box>
                                {/* Filter Block */}
                                <div className="ax-filter-block">
                                    <div className="ax-filter-grid">
                                        <div className="ax-filter-item">
                                            <label>👤 Tên người chơi</label>
                                            <input
                                                type="text"
                                                placeholder="Nhập tên đăng nhập"
                                                value={searchName}
                                                onChange={(e) => setSearchName(e.target.value)}
                                                style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                            />
                                        </div>

                                        <div className="ax-filter-item">
                                            <label>◉ Trạng thái</label>
                                            <select
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                                style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                            >
                                                <option value="All">Toàn bộ</option>
                                                <option value="Success">Thành công</option>
                                            </select>
                                        </div>

                                        <div className="ax-filter-item" style={{ flexDirection: "row", gap: "8px" }}>
                                            <button className="ax-btn-search-red" onClick={() => setLoad(true)}>
                                                🔍 Tìm kiếm
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="ax-table-wrapper">
                                    <Table>
                                        <TableHead sx={{ backgroundColor: "#f0f2f5" }}>
                                            <TableRow>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none" }}>Tên người chơi</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none" }}>Mã Giftcode</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none" }}>Loại Giftcode</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none" }}>Ngày sử dụng</TableCell>
                                                <TableCell sx={{ padding: "12px 10px", color: "#333 !important", fontWeight: "600 !important", borderBottom: "none", textAlign: "center" }}>Số tiền</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data && data.length > 0 ? (
                                                data.map((item) => (
                                                    <TableRow key={item._id} hover>
                                                        <TableCell sx={{ fontWeight: "600", padding: "12px 10px", color: "#555" }}>
                                                            {item?.user?.username || "Ẩn danh"}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "bold", padding: "12px 10px", color: "#1890ff" }}>
                                                            {item.detail ? item.detail.replace("Nhập mã khuyến mãi", "").trim() : "N/A"}
                                                        </TableCell>
                                                        <TableCell sx={{ padding: "12px 10px" }}>
                                                            <span style={{ padding: "4px 12px", borderRadius: "4px", background: "#f6ffed", color: "#52c41a", border: "1px solid #b7eb8f", fontSize: "12px", fontWeight: "bold" }}>
                                                                VIP Code
                                                            </span>
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "500", padding: "12px 10px", color: "#666" }}>
                                                            {formatDate(item.createdAt)}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "bold", padding: "12px 10px", color: "#ff4d4f", textAlign: "center" }}>
                                                            +{Number(item.money || 0).toLocaleString("vi-VN")}
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} style={{ fontSize: "14px", textAlign: "center", padding: "30px", color: "#888" }}>
                                                        Chưa có lịch sử nhập mã
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            </Box>
                        </div>
                        {totalPages > 1 && (
                            <Box sx={{ display: "flex", justifyContent: "center", pt: 3, pb: 3 }}>
                                <Pagination color="primary" count={totalPages} page={page} onChange={handleChangePage} />
                            </Box>
                        )}
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default Promo;